// src/shared/config/env.js

export const localUrl = 'http://tykven.local/v2';
export const stagingUrl = 'https://staging.app.tykven.com/v2';
export const productionUrl = 'https://client.tykven.com/v2';

function getBaseUrl(name) {
  switch (name) {
    case 0:
      return localUrl;
    case 1:
      return stagingUrl;
    case 2:
      return productionUrl;
    default:
      throw new Error(`Unknown base URL name: ${name}`);
  }
}

export const BASE_URLS = {
    MAIN: getBaseUrl(1),

    // Add other base URLs as needed
    SECONDARY: process.env.REACT_APP_SECONDARY_API_URL || '',
  };
  
  export const ENV_CONFIG = {
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
    apiTimeout: 20000,
    devicePlatform: 7, // Web platform identifier
  };
  export default BASE_URLS;


